import { connect } from 'react-redux';
import { compose } from 'ramda';

import HistoryList from 'components/HistoryList';
import withPageLoader from 'components/withPageLoader';

import { requestReports } from 'store/actionCreators/reports/recent';
import { getUserRequestReportsParams, getUserId } from 'store/selectors/user';
import {
  getReportsShouldShowLoading,
  getSortedRecentReportsWithToday,
} from 'store/selectors/reports/recent';

const mapStateToProps = state => {
  const patientId = getUserId(state);
  return {
    data: getSortedRecentReportsWithToday(patientId)(state),
  };
};

export default compose(
  connect(mapStateToProps),
  withPageLoader({
    loadingSelector: state => {
      const patientId = getUserId(state);
      return getReportsShouldShowLoading(patientId)(state);
    },
    initialActionArgsSelector: getUserRequestReportsParams,
    initialAction: requestReports,
  }),
)(HistoryList);
